import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { EmrSystem } from '../models/emr-system.model';

@Injectable()
export class EmrSystemsService extends ApiService {
  private http = inject(HttpClient);

  getList(): Observable<EmrSystem[]> {
    const url = `${environment.captureApi.url}/emr_systems`;

    return this.http.get<EmrSystem[]>(url);
  }
}
